export default {"src":"/_next/static/media/quality-contractor.328fff24.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};